<template>
  
  <Teleport to="body">
    <ThanksPopup />
    <ErrorMessage />
    <Transition name="fade">
      <div class="popform" ref="main" id="callform-app" v-show="show">
        <div class="popform__outer">
          <div class="popform__wrapper-section wrapper-section">
            <Backlink class="popform__backlink"  :white="slidenumber==5" @click="slidenumber < 7?$store.commit('prevSlide'):false" :enabled="slidenumber < 7"/>
            <form class="popform__form">
              <SlideWindow :slidenumber="slidenumber" @click="toggleDebug">
                <component v-for="(value, i) in (lastslidenumber + 1)" :key="i" 
                          :is="`slide${i}`" 
                          :active="i == slidenumber"
                          :disabled="i != slidenumber"
                          :timer="i == 7?timervalue:undefined"
                          @sendAgain="sendAnotherSms"
                          :class="{'active':i == slidenumber}"
                          :title="slidetitles[i]" />
              </SlideWindow>
            </form>
            <Transition name="fade">
              <button class="popform__next" 
                      :class="{'popform__next_center':slidenumber == 5,'popform__next_loading':loading}" 
                      tabindex="0" 
                      v-if="!isLastSlide && !(slidenumber == 5 && nextDisabled)" 
                      @click="toNext" 
                      :disabled="nextDisabled || (slidenumber == 7 && code.length < 4)" 
                      v-html="(!loading)?buttonText:loadsvg">
              </button>
            </Transition>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Backlink from './components/backlink.vue';
import SlideWindow from './components/SlideWindow.vue';
import Slide0 from './components/slides/Slide0.vue';
import Slide1 from './components/slides/Slide1.vue';
import Slide2 from './components/slides/Slide2.vue';
import Slide3 from './components/slides/Slide3.vue';
import Slide4 from './components/slides/Slide4.vue';
import Slide5 from './components/slides/Slide5.vue';
import Slide6 from './components/slides/Slide6.vue';
import Slide7 from './components/slides/Slide7.vue';
import Slide8 from './components/slides/Slide8.vue';
import ErrorMessage from './components/ErrorMessage.vue';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import ThanksPopup from './components/ThanksPopup.vue';

export default {
  name: 'App',
  data: ()=>({
    ymactions: [
      'znakomstvo264074547',
      'chat_hotite_zastrakhovat264074567',
      'Adress264074668',
      'pasport264074672',
      'contact264074738',
      'vybor_programm264074792',
      'proverka_dannyh264074834',
      'sms264074874',
    ],
    timer: 0,
    tries: -1,
    verifyTries: 0,
    timervalue: undefined,
    fieldsStatus: {
      fullname: false,
      birthdate: false,
      'p-number': false,
      'p-releasedate': false,
      tel: false,
      email: false
    },
    bodyScrollLock: undefined,
    loadsvg: '<img src="data:image/png;base64,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">'
  }),
  provide() {
    return {
      fieldsStatus: this.fieldsStatus
    }
  },
  methods: {
    ...mapActions(['getExampleLink', 'payAndSendForm', 'sendSMScode', 'loaderAfterMap', 'SMScodeValidation']),
    toggleDebug(e){
      if (e.target.classList.contains('pfslide__title') ||
          e.target.classList.contains('debugwindow') ||
          e.target.closest('.debugwindow'))
        this.$store.commit('setDebug', !this.debug)
    },
    async sendAnotherSms(){
      clearInterval(this.timer)
      if (this.timervalue == -1)
        return
      this.tries++
      if (this.tries == 3) 
        this.timervalue = -1
      else {
        this.timervalue = 0
        this.timer = setInterval(()=>this.timervalue++, 1000)
      }
      await this.sendSMScode()
    },
    async toNext(){
      if (this.slidenumber == 2)
        await this.loaderAfterMap()
      if (this.slidenumber == this.lastslidenumber - 3)
        await this.getExampleLink()
      if (this.slidenumber == this.lastslidenumber - 2) 
        await this.sendAnotherSms()
      if (this.slidenumber == this.lastslidenumber - 1) {
        if (this.smsOk) {
          clearTimeout(this.timer)
          return await this.payAndSendForm()
        }
        else {
          console.log(this.code)
          this.verifyTries++
          return await this.SMScodeValidation(this.code)
        }
      }
      if (!this.error.show) {
        this.$store.commit('nextSlide')
        this.$refs.main.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  components: { Backlink, SlideWindow, Slide0, Slide1, Slide2, Slide3, Slide4, Slide5, Slide6, Slide7, Slide8, ErrorMessage, ThanksPopup },
  computed: {
    ...mapState(['code','show','slidenumber','lastslidenumber','slidetitles', 'DaData','client', 'smsOk','error','debug']),
    ...mapGetters(['buttonText', 'isLastSlide', 'isAddressOk','loading']),
    maxStep(){
      if (!this.fieldsStatus.fullname || !this.client.sex || !this.fieldsStatus.birthdate) return 0
      if (!this.client.object.type) return 1
      if (!this.isAddressOk) return 2
      if (!this.fieldsStatus['p-releasedate'] || !this.fieldsStatus['p-number'] || !this.client.pob) return 3
      if (!this.fieldsStatus.tel || !this.fieldsStatus.email) return 4
      if (!this.client.program) return 5
      if (this.code.length < 4 && !this.verifyTries && !this.tries) return 7
      return 8
    },
    nextDisabled(){
      return this.maxStep <= this.slidenumber
    }
  },
  created(){
    document.querySelectorAll('.callform').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        if (btn.closest('section').classList.contains('hero')) {
          console.log('unznat_stoimost1264074470')
          window.ym(90600182,'reachGoal','unznat_stoimost1264074470')
        } else {
          console.log('unznat_stoimost2264074493')
          window.ym(90600182,'reachGoal','unznat_stoimost2264074493')
        }
        if (this.slidenumber == this.lastslidenumber) return this.$store.commit('setThanksShow', true)
        this.$store.commit('setShow', true)
      })
    })
  },
  mounted(){
    let ordernumber = new URLSearchParams(window.location.search).get('ordernumber')
    if (ordernumber) {
      this.$store.dispatch('showFinishScreen', ordernumber)
    }
  },
  watch: {
    slidenumber(v) {
      if(v && this.ymactions[v]) {
        window.ym(90600182,'reachGoal',this.ymactions[v])
        console.log(this.ymactions[v])
        this.ymactions[v] = false
      }
    },
    show(v){
      if (v) {
        disableBodyScroll(this.$refs.main)
        if (this.ymactions[0]) {
          window.ym(90600182,'reachGoal',this.ymactions[0])
          console.log(this.ymactions[0])
          this.ymactions[0] = false
        }
      }
      else
        enableBodyScroll(this.$refs.main)
    }
  }
}
</script>

<style lang="sass">
body
  width: 100%
@keyframes rotating 
  0%
    transform: rotate(0deg)  
  100%
    transform: rotate(360deg)  

.popform__pageactions
  display: none
.fade-enter-active,.fade-leave-active
  transition: opacity .4s ease-out
.fade-enter-from,.fade-leave-to,.fastfade-enter-from,.fastfade-leave-to,.slowfade-enter-from,.slowfade-leave-to
  opacity: 0
  pointer-events: none
.fastfade-enter-active,.fastfade-leave-active
  transition: opacity .2s ease-out
.slowfade-enter-active,.slowfade-leave-active
  transition: opacity 1s ease-out

.popform
  overflow-y: auto
  --headeroffset: 78px
  @include for-mob
    --headeroffset: 64px
  position: fixed
  z-index: 1000000
  top: var(--headeroffset)
  left: 0
  width: 100%
  height: calc(100% - var(--headeroffset))
  background: white
  &__outer
    width: 100%
    min-height: 100%
    overflow: hidden
  &__wrapper-section
    @include since(1280.02px)
      width: 100%
    @include for-mob
      width: calc(100% - 32px)
  &__backlink
    -webkit-transform: translate3d(0,0,0)
  &__hidable
    transition: opacity .4s ease-out
    &-hidden
      opacity: 0
      user-select: none
      pointer-events: none
  &__next
    cursor: pointer
    width: 327px
    height: 56px
    max-width: 100%
    display: flex
    align-items: center
    justify-content: center
    text-align: center
    margin: 31px auto 32px
    padding-bottom: 0
    padding-top: 3px
    transition: .3s ease-out
    box-shadow: 0px 24px 24px rgba(242, 40, 87, 0.16)
    border-radius: 8px
    font-weight: 500
    font-size: 18px
    line-height: 136%    
    letter-spacing: globalvars.$onespacing
    color: colors.$notred
    background: colors.$newred
    @include for-mob
      width: 100%
    &_center
      position: fixed
      z-index: 99
      left: 50%
      margin: 0
      transform: translateX(-50%)
      bottom: 32px
      @include for-mob
        width: calc(100% - 32px)
        margin: 0
    img
      width: 40px
      transform-origin: center center
      display: block
      animation: rotating 2s linear infinite
    &:hover, &:focus-visible
      &:not(.popup__next_loading)
        background: colors.$darkred
    &:disabled
      background: colors.$btngray
      box-shadow: 0px 24px 24px rgba(210, 212, 218, 0.16)      
    &:disabled, &_loading
      pointer-events: none
</style>
